/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import './BoxPort.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { FormGroup, Input, Label } from 'reactstrap';
import activated from '../../../../../Res/Icon/activated.png';
import { checkPendingFaxes } from '../../../../../actions/Fax';
import { NUMBER_TYPES_LABEL } from '../../../../../lib/constants';

const BoxPort = ({ port, onPortSelect, selected, resetE911, assignE911ToPort, boxDetails, checkPendingFaxes }) => {
  const containerClassName = selected ? 'boxPortContainer selected' : 'boxPortContainer';
  const [e911Check, setE911Check] = useState(!!port.e911Number);
  const token = localStorage.getItem('jwtToken') || null;

  const onPortClick = (ev) => {
    ev.stopPropagation();
    onPortSelect(port);
    if (port?.assignedNumberRef?.type === "fax") {
      checkPendingFaxes(token, port?.assignedNumberRef?.number)
    }
  }
  return (
    <div className={containerClassName}>
      <div
        onClick={ev => { onPortClick(ev) }}
      >
        {port.portActivated ? <img className="activated-icon" src={activated} alt="edit" /> : null}

        <div className="portLabel" id={port?.boxPortNumber?.replace(/\s+/g, '_')?.toLowerCase()}>
          {port.boxPortNumber}
        </div>
        <div className="portInfo">
          <div className="infoLabel">
            <FontAwesomeIcon fixedWidth className="labelIcon" icon="signature" />
            <h5 id="port-name-label">Port Type </h5>
          </div>
          <span id="port-name-value">
            {NUMBER_TYPES_LABEL[port.assignedNumberRef ? port.assignedNumberRef.type : 'unassigned']}
          </span>
        </div>
        <div className="portInfo">
          <div className="infoLabel">
            <FontAwesomeIcon fixedWidth className="labelIcon" icon="hashtag" />
            <h5 id="port-number-label">Assigned Number</h5>
          </div>
          <span className="date" id="port-number-value">
            {(port.assignedNumberRef && port.assignedNumberRef.number) || 'Unassigned'}
          </span>
        </div>
      </div>
      <div>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input
              id={`e911_enabled_${port?.boxPortNumber?.split(' ')[1]}`}
              type="checkbox"
              checked={!!boxDetails?.e911Number || !!port.e911Enabled}
              disabled
              onChange={() => {
                setE911Check(!e911Check);
                if (e911Check) {
                  resetE911(port);
                } else {
                  assignE911ToPort(port);
                }
              }}
            />
            E911 Enabled
          </Label>
        </FormGroup>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input type="checkbox" checked={!!port?.vmNumber} disabled />
            Voice Mail
          </Label>
        </FormGroup>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input disabled type="checkbox" checked={port?.assignedNumberRef?.isForwarded} />
            Forward
          </Label>
        </FormGroup>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  boxDetails: state.AppState.boxDetails.box,
});
const mapDispatchToProps = dispatch => ({
  checkPendingFaxes: (token, number) => dispatch(checkPendingFaxes(token, number)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoxPort);
